import addStepAppMetadata from '@/lib/workflows/addStepAppMetadata.js';
import buildAppMetadataMaps from '@/redux/selectors/pieveSelectors/lib/buildAppMetadataMaps.js';

// A workflow snapshot's steps with each one's app icon and name, from the client app metadata plus the snapshot's own
// `appMetadataById`. Every version of a workflow is drawn from the same lookups the draft is.
const hydrateWorkflowStepApps = ({ steps, appsMetadataItems, appMetadataById }) => {
  const { metadataById, metadataBySlug } = buildAppMetadataMaps({ appsMetadataItems, appMetadataById });

  return addStepAppMetadata(steps, metadataById, metadataBySlug);
};

export default hydrateWorkflowStepApps;
